<template>
  <div class="pagina ativa" id="paginaCotas">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;border-bottom:2px solid #4a5c2f;padding-bottom:10px;">
      <div class="pagina-titulo" style="margin:0;border:none;padding:0;display:flex;align-items:center;gap:9px;"><Award :size="20" /> Cotas Contempladas</div>
      <span style="font-size:11px;color:#aaa;">{{ ultimaImportacao ? 'última importação: ' + ultimaImportacao : '' }}</span>
    </div>

    <div v-if="ehAdmin" style="background:white;border-radius:10px;padding:16px 18px;margin:14px 0;box-shadow:0 2px 8px rgba(0,0,0,0.07);">
      <div style="display:flex;align-items:center;gap:7px;font-weight:bold;color:#4a5c2f;font-size:13px;margin-bottom:10px;"><FileDown :size="14" /> Importar PDFs de Cotas Contempladas</div>
      <p style="color:#555;font-size:12px;margin-bottom:12px;">Selecione um ou mais PDFs de cotas contempladas. O sistema atualiza automaticamente cotas existentes e insere novas.</p>
      <div class="area-upload" style="border:2px dashed #ccc;border-radius:8px;padding:18px;text-align:center;cursor:pointer;color:#888;font-size:13px;" @click="$refs.arquivoPDF.click()">
        {{ pdfFilesQueue.length ? pdfFilesQueue.length + ' arquivo(s) selecionado(s)' : 'Clique para selecionar os PDFs (aceita múltiplos)' }}
      </div>
      <input ref="arquivoPDF" type="file" accept=".pdf" multiple style="display:none;" @change="selecionarPDFs" />
      <div v-if="pdfFilesQueue.length" style="margin-top:14px;display:flex;flex-direction:column;gap:8px;">
        <div v-for="(f, i) in pdfFilesQueue" :key="i" style="display:flex;align-items:center;gap:10px;padding:10px 14px;background:#fafafa;border:1px solid #e0e0e0;border-radius:8px;font-size:13px;">
          <div style="width:28px;height:28px;background:#fef3c7;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;color:#92400e;flex-shrink:0;">PDF</div>
          <span style="flex:1;">{{ f.name }}</span>
          <span style="font-size:11px;color:#aaa;">{{ (f.size / 1024).toFixed(0) }} KB</span>
          <span :style="{ fontSize: '11px', color: pdfStatus[i] && pdfStatus[i].cor ? pdfStatus[i].cor : '#aaa' }">{{ (pdfStatus[i] && pdfStatus[i].texto) || 'Aguardando' }}</span>
        </div>
      </div>
      <div style="display:flex;gap:10px;align-items:center;flex-wrap:wrap;">
        <button :disabled="!pdfFilesQueue.length || importandoPdf" @click="importarPDFs" style="margin-top:14px;padding:8px 18px;font-size:13px;">IMPORTAR COTAS</button>
        <button v-if="ultimaImportacao" :disabled="excluindoImportacao" @click="excluirUltimaImportacao" style="display:inline-flex;align-items:center;gap:5px;margin-top:14px;padding:8px 18px;font-size:13px;background:#c0392b;"><Trash2 :size="14" /> Excluir Ultima Importacao</button>
      </div>
      <div class="status" :class="statusImportarPdf.tipo === 'sucesso' ? 'sucesso' : (statusImportarPdf.tipo === 'erro' ? 'erro-msg' : '')">{{ statusImportarPdf.texto }}</div>
    </div>

    <div class="seg-tabs-cotas" style="margin-top:14px;">
      <button class="seg-tab-c" :class="{ ativo: seg === 'VEÍCULOS' }" @click="setSeg('VEÍCULOS')">Veículos</button>
      <button class="seg-tab-c" :class="{ ativo: seg === 'IMÓVEIS' }" @click="setSeg('IMÓVEIS')">Imóveis</button>
    </div>

    <div class="cotas-filtros">
      <div class="cf-group">
        <span class="cf-label">Administradora</span>
        <select v-model="filtros.adm">
          <option value="">Todas</option>
          <option v-for="a in administradoras" :key="a" :value="a">{{ a }}</option>
        </select>
      </div>
      <div class="cf-group"><span class="cf-label">Crédito mín.</span><input v-model="filtros.cMin" type="text" placeholder="R$ 0" @input="mascaraValor($event, 'cMin')"></div>
      <div class="cf-group"><span class="cf-label">Crédito máx.</span><input v-model="filtros.cMax" type="text" placeholder="Qualquer" @input="mascaraValor($event, 'cMax')"></div>
      <div class="cf-group"><span class="cf-label">Entrada mín.</span><input v-model="filtros.eMin" type="text" placeholder="R$ 0" @input="mascaraValor($event, 'eMin')"></div>
      <div class="cf-group"><span class="cf-label">Entrada máx.</span><input v-model="filtros.eMax" type="text" placeholder="Qualquer" @input="mascaraValor($event, 'eMax')"></div>
      <div class="cf-group"><span class="cf-label">Parcela máx.</span><input v-model="filtros.pMax" type="text" placeholder="Qualquer" @input="mascaraValor($event, 'pMax')"></div>
      <button class="btn-filtrar" @click="renderizado++">Filtrar</button>
    </div>

    <div class="cotas-bar">
      <span class="cotas-bar-info">{{ cotasFiltradas.length }} cota{{ cotasFiltradas.length !== 1 ? 's' : '' }}</span>
      <div class="cotas-bar-sel">
        <span style="font-size:12px;color:#666;">{{ selecionadas.length ? selecionadas.length + ' selecionada' + (selecionadas.length > 1 ? 's' : '') : '' }}</span>
        <button @click="limparSelecao" style="padding:6px 14px;background:#888;color:white;border:none;border-radius:5px;font-size:12px;cursor:pointer;margin:0;">Limpar Seleção</button>
        <button class="btn-proposta" :class="{ on: selecionadas.length > 0 }" @click="abrirModalProposta">Gerar proposta</button>
      </div>
    </div>

    <div class="cotas-grid">
      <p v-if="carregando" style="grid-column:1/-1;text-align:center;padding:40px;color:#aaa;">Carregando cotas...</p>
      <p v-else-if="!cotasFiltradas.length" style="grid-column:1/-1;text-align:center;padding:40px;color:#aaa;">Nenhuma cota com esses filtros.</p>
      <template v-else>
        <div
          v-for="c in cotasFiltradas"
          :key="c.codigo"
          class="cota-card"
          :class="{ sel: isSelecionada(c), bloqueado: !isSelecionada(c) && isBloqueada(c) }"
          @click="toggleCota(c)"
        >
          <div class="cc-chk">{{ isSelecionada(c) ? '✓' : '' }}</div>
          <div class="cc-adm">
            <div class="cc-logo" :style="{ background: getLogo(c.administradora).bg, color: getLogo(c.administradora).fg }">{{ getLogo(c.administradora).sig }}</div>
            <span class="cc-nome">{{ c.administradora }}</span>
            <span class="cc-badge" :class="{ reservada: c.status === 'Reservada' }">{{ c.status === 'Reservada' ? 'Reservada' : 'Disponível' }}</span>
          </div>
          <div class="cc-credito">{{ fmt(c.credito) }} <span>crédito</span></div>
          <hr class="cc-div">
          <div class="cc-fields">
            <div><div class="cc-fl">Entrada</div><div class="cc-fv g">{{ fmt(c.entrada) }}</div></div>
            <div><div class="cc-fl">Entrada %</div><div class="cc-fv">{{ c.entrada_pct }}%</div></div>
            <div style="grid-column:1/-1"><div class="cc-fl">Parcelas</div><div class="cc-fv" style="font-size:12px;white-space:normal;">
              {{ (c.valor_parcelas && c.valor_parcelas.toString().indexOf('+') > -1) ? c.valor_parcelas : (c.parcelas + 'x de ' + fmt(parseParcVal(c.valor_parcelas))) }}
            </div></div>
            <div><div class="cc-fl">Saldo devedor</div><div class="cc-fv r">{{ fmt(Math.round(c.parcelas * parseParcVal(c.valor_parcelas))) }}</div></div>
          </div>
          <div class="cc-cod">{{ c.codigo }} · {{ c.prox_vencimento }}</div>
          <div v-if="vencBadge(c).text" class="cc-venc-badge" :style="vencBadge(c).style">{{ vencBadge(c).text }}</div>
        </div>
      </template>
    </div>

    <!-- MODAL PROPOSTA -->
    <div v-if="modalAberto" class="app-drawer-overlay">
      <div class="app-drawer" style="padding:0;">
        <div style="display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #eee;background:#4a5c2f;">
          <span style="font-size:15px;font-weight:bold;color:white;">Proposta Comercial</span>
          <button @click="modalAberto = false" style="display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.2);border:none;color:white;width:28px;height:28px;border-radius:50%;cursor:pointer;padding:0;margin:0;"><X :size="13" /></button>
        </div>
        <div style="padding:20px;flex:1;overflow-y:auto;">
          <div style="background:#f5f7f0;border-radius:8px;padding:12px 15px;margin-bottom:14px;display:flex;align-items:center;justify-content:space-between;">
            <div style="display:flex;align-items:center;gap:8px;">
              <div style="width:24px;height:24px;border-radius:5px;display:flex;align-items:center;justify-content:center;font-size:8px;font-weight:700;" :style="{ background: getLogo(selecionadas[0].administradora).bg, color: getLogo(selecionadas[0].administradora).fg }">{{ getLogo(selecionadas[0].administradora).sig }}</div>
              <span style="font-size:13px;font-weight:bold;color:#333;">{{ selecionadas[0].administradora }}</span>
            </div>
            <span style="font-size:11px;background:#e8f5e9;color:#2e7d32;padding:3px 8px;border-radius:10px;">{{ selecionadas[0].segmento }}</span>
          </div>
          <div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin-bottom:14px;">
            <div class="card" style="padding:10px;"><div class="card-label" style="font-size:10px;">Crédito total</div><div class="card-valor" style="font-size:16px;">{{ fmt(totaisProposta.credito) }}</div></div>
            <div class="card" style="padding:10px;"><div class="card-label" style="font-size:10px;">Entrada total</div><div class="card-valor" style="font-size:16px;color:#2e7d32;">{{ fmt(totaisProposta.entrada) }}</div></div>
            <div class="card" style="padding:10px;"><div class="card-label" style="font-size:10px;">Saldo devedor</div><div class="card-valor" style="font-size:16px;color:#c0392b;">{{ fmt(totaisProposta.saldo) }}</div></div>
          </div>
          <div v-if="selecionadas.length > 1" style="margin-bottom:14px;background:#fff9e6;border:1px solid #ffe082;border-radius:8px;padding:10px 13px;font-size:12px;color:#856404;">
            <strong>Parcelas combinadas:</strong> {{ prazoCombinadoTexto }}
          </div>
          <div style="margin-bottom:14px;">
            <div v-for="(c, i) in selecionadas" :key="c.codigo" style="border:1px solid #eee;border-radius:8px;padding:10px 13px;margin-bottom:6px;">
              <div style="display:flex;justify-content:space-between;margin-bottom:5px;">
                <span style="font-size:10px;color:#aaa;">{{ c.codigo }}</span>
                <span style="font-size:13px;font-weight:bold;">{{ fmt(c.credito) }}</span>
              </div>
              <div style="display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:4px;font-size:11px;">
                <div><div style="color:#aaa;font-size:9px;">Entrada</div><div style="font-weight:600;">{{ fmt(entradasAjustadas[i]) }}</div></div>
                <div><div style="color:#aaa;font-size:9px;">Parcela</div><div style="font-weight:600;">{{ fmt(parseParcVal(c.valor_parcelas)) }}/mês</div></div>
                <div><div style="color:#aaa;font-size:9px;">Prazo</div><div style="font-weight:600;">{{ c.parcelas }}x</div></div>
                <div><div style="color:#aaa;font-size:9px;">Saldo dev.</div><div style="font-weight:600;color:#c0392b;">{{ fmt(Math.round(c.parcelas * parseParcVal(c.valor_parcelas))) }}</div></div>
              </div>
            </div>
          </div>
          <div style="margin-bottom:14px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;padding:12px 15px;">
            <div style="display:flex;align-items:center;gap:6px;font-size:11px;color:#0369a1;text-transform:uppercase;letter-spacing:.04em;margin-bottom:10px;font-weight:bold;"><Pencil :size="12" /> Ajustar Entrada</div>
            <div v-for="(c, i) in selecionadas" :key="c.codigo" style="display:flex;align-items:center;gap:10px;margin-bottom:8px;">
              <span style="font-size:12px;color:#555;min-width:120px;">{{ selecionadas.length > 1 ? 'Cota ' + (i + 1) + ' — ' : '' }}{{ fmt(c.credito) }}</span>
              <div style="display:flex;flex-direction:column;gap:2px;">
                <span style="font-size:10px;color:#888;">Entrada (R$)</span>
                <input type="text" v-model="entradasInput[i]" @input="recalcularProposta" style="width:140px;padding:6px 10px;border:1px solid #bae6fd;border-radius:5px;font-size:13px;font-weight:bold;color:#0369a1;margin:0;" />
              </div>
              <div style="font-size:11px;color:#888;">Parcela: {{ fmt(parseParcVal(c.valor_parcelas)) }}/mês × {{ c.parcelas }}x</div>
            </div>
          </div>
          <div style="font-size:11px;color:#888;text-transform:uppercase;letter-spacing:.04em;margin-bottom:6px;">Mensagem — editável</div>
          <textarea v-model="mensagemProposta" style="width:100%;min-height:220px;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:12px;font-size:11px;line-height:1.75;color:#166534;font-family:monospace;resize:vertical;outline:none;" spellcheck="false"></textarea>
        </div>
        <div class="app-drawer-acoes" style="margin:0;border-radius:0;background:#fafafa;">
          <button @click="modalAberto = false" style="background:white;border:1px solid #ccc;color:#333;">Cancelar</button>
          <button @click="gerarPDFCota" style="background:#555;">Baixar PDF</button>
          <button @click="copiarPropostaCota">{{ textoBtnCopiar }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, apiDelete, getSession, getNomeEmpresaCache } from '../api'
import { Award, FileDown, Trash2, X, Pencil } from 'lucide-vue-next'

const LOGOS_ADM = {
  'HS CONSÓRCIOS': { sig: 'HS', bg: '#e8f0fe', fg: '#1a56db' },
  'H S': { sig: 'HS', bg: '#e8f0fe', fg: '#1a56db' },
  'CAIXA CONSÓRCIOS': { sig: 'CEF', bg: '#fef3c7', fg: '#92400e' },
  CAIXA: { sig: 'CEF', bg: '#fef3c7', fg: '#92400e' },
  CNP: { sig: 'CNP', bg: '#fce7f3', fg: '#9d174d' },
  'ITAÚ': { sig: 'ITÁ', bg: '#fff3cd', fg: '#92400e' },
  'ITAÚ MOTO': { sig: 'ITÁ', bg: '#fff3cd', fg: '#92400e' },
  ITAU: { sig: 'ITÁ', bg: '#fff3cd', fg: '#92400e' },
  BRADESCO: { sig: 'BRA', bg: '#fce7f3', fg: '#9d174d' },
  'PORTO SEGURO': { sig: 'PS', bg: '#e0f2fe', fg: '#0369a1' },
  PORTO: { sig: 'PS', bg: '#e0f2fe', fg: '#0369a1' },
  EMBRACON: { sig: 'EMB', bg: '#f0fdf4', fg: '#166534' },
  SERELLO: { sig: 'SRL', bg: '#f5f3ff', fg: '#5b21b6' },
  MYCON: { sig: 'MYC', bg: '#fdf4ff', fg: '#7e22ce' },
  SANTANDER: { sig: 'SAN', bg: '#fef2f2', fg: '#991b1b' },
  SICOOB: { sig: 'SCB', bg: '#ecfdf5', fg: '#065f46' },
  SICREDI: { sig: 'SCR', bg: '#ecfdf5', fg: '#065f46' },
  RODOBENS: { sig: 'RDB', bg: '#fffbeb', fg: '#92400e' },
  GAZIN: { sig: 'GAZ', bg: '#f0f9ff', fg: '#0369a1' },
  MAGALU: { sig: 'MAG', bg: '#eff6ff', fg: '#1d4ed8' },
  UNICCOB: { sig: 'UNI', bg: '#fdf4ff', fg: '#7e22ce' },
  VOLKSWAGEN: { sig: 'VW', bg: '#dbeafe', fg: '#1e40af' },
  VOLKS: { sig: 'VW', bg: '#dbeafe', fg: '#1e40af' },
  YAMAHA: { sig: 'YAM', bg: '#fef9c3', fg: '#854d0e' },
  SERVOPA: { sig: 'SVP', bg: '#f1f5f9', fg: '#475569' },
  ZEMA: { sig: 'ZEM', bg: '#f0fdf4', fg: '#166534' },
  REMAZA: { sig: 'RMZ', bg: '#fff7ed', fg: '#9a3412' },
  DISAL: { sig: 'DIS', bg: '#f8fafc', fg: '#475569' }
}

export default {
  name: 'PaginaCotas',
  components: { Award, FileDown, Trash2, X, Pencil },
  data() {
    return {
      seg: 'VEÍCULOS',
      cotasTodos: [],
      carregando: false,
      ultimaImportacao: '',
      filtros: { adm: '', cMin: '', cMax: '', eMin: '', eMax: '', pMax: '' },
      renderizado: 0,
      selecionadas: [],
      modalAberto: false,
      entradasInput: [],
      mensagemProposta: '',
      textoBtnCopiar: 'Copiar WhatsApp',
      pdfFilesQueue: [],
      pdfStatus: [],
      importandoPdf: false,
      statusImportarPdf: { texto: '', tipo: '' },
      excluindoImportacao: false
    }
  },
  computed: {
    ehAdmin() { return getSession().perfil === 'admin' },
    administradoras() {
      const adms = {}
      this.cotasTodos.forEach(c => { if (c.administradora) adms[c.administradora] = true })
      return Object.keys(adms).sort()
    },
    cotasFiltradas() {
      this.renderizado // eslint-disable-line no-unused-expressions
      const adm = this.filtros.adm
      const cMin = this.parseValInput(this.filtros.cMin)
      const cMax = this.parseValInput(this.filtros.cMax) || Infinity
      const eMin = this.parseValInput(this.filtros.eMin)
      const eMax = this.parseValInput(this.filtros.eMax) || Infinity
      const pMax = this.parseValInput(this.filtros.pMax) || Infinity
      return this.cotasTodos.filter(c => {
        if (adm && c.administradora !== adm) return false
        if (c.credito < cMin || c.credito > cMax) return false
        if (c.entrada < eMin || c.entrada > eMax) return false
        if (this.parseParcVal(c.valor_parcelas) > pMax) return false
        return true
      })
    },
    totaisProposta() {
      const cs = this.selecionadas
      const entradas = this.entradasAjustadas
      return {
        credito: cs.reduce((s, c) => s + c.credito, 0),
        entrada: entradas.reduce((s, v) => s + v, 0),
        saldo: cs.reduce((s, c) => s + Math.round(c.parcelas * this.parseParcVal(c.valor_parcelas)), 0)
      }
    },
    entradasAjustadas() {
      return this.selecionadas.map((c, i) => {
        const raw = this.entradasInput[i]
        const val = raw !== undefined ? (this.parseValInput(raw) || c.entrada) : c.entrada
        return val
      })
    },
    prazoCombinadoTexto() {
      const cs = this.selecionadas
      if (cs.length <= 1) return ''
      const parcs = cs.map(c => ({ p: c.parcelas, v: this.parseParcVal(c.valor_parcelas) }))
      const unicos = [...new Set(parcs.map(x => x.p))].sort((a, b) => a - b)
      const passos = []
      let prev = 0
      unicos.forEach(prazo => {
        const ativas = parcs.filter(x => x.p >= prazo)
        const soma = ativas.reduce((s, x) => s + x.v, 0)
        const dur = prazo - prev
        if (dur > 0) passos.push({ qtd: dur, soma })
        prev = prazo
      })
      return passos.map(s => s.qtd + 'x de ' + this.fmt(s.soma) + '/mês').join(' + ')
    }
  },
  created() {
    this.carregar()
  },
  methods: {
    fmt(v) { return 'R$ ' + Math.round(v || 0).toLocaleString('pt-BR') },
    parseParcVal(v) {
      if (!v) return 0
      let m = v.toString().match(/([\d.]+,\d{2})\s*$/)
      if (!m) m = v.toString().match(/([\d.,]+)/)
      if (!m) return 0
      return parseFloat(m[1].replace(/\./g, '').replace(',', '.')) || 0
    },
    parseValInput(v) { return parseFloat((v || '').toString().replace(/\./g, '').replace(',', '.')) || 0 },
    mascaraValor(e, campo) {
      let v = e.target.value.replace(/\D/g, '')
      if (!v) { this.filtros[campo] = ''; return }
      v = (parseInt(v, 10) / 100).toFixed(2)
      v = v.replace('.', ',')
      v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      this.filtros[campo] = v
    },
    vencBadge(c) {
      if (!c.prox_vencimento) return { text: '', style: {} }
      const partsV = c.prox_vencimento.toString().replace('VENC ', '').split('/')
      if (partsV.length !== 3) return { text: '', style: {} }
      const dv = new Date(+partsV[2], +partsV[1] - 1, +partsV[0])
      const hoje = new Date()
      const diff = Math.round((dv - hoje) / 86400000)
      if (diff <= 15 && diff >= 0) return { text: 'Vence em ' + diff + ' dia' + (diff !== 1 ? 's' : ''), style: {} }
      if (diff < 0) return { text: 'Vencida', style: { background: '#fde8e8', color: '#9b1c1c' } }
      return { text: '', style: {} }
    },
    getLogo(adm) {
      const key = Object.keys(LOGOS_ADM).find(k => (adm || '').toUpperCase().indexOf(k) > -1)
      return key ? LOGOS_ADM[key] : { sig: (adm || '').slice(0, 3).toUpperCase(), bg: '#f1f5f9', fg: '#475569' }
    },
    async setSeg(s) {
      this.seg = s
      this.selecionadas = []
      await this.carregar()
    },
    async carregar() {
      this.carregando = true
      const r = await apiGet('cotas/listar', { segmento: this.seg })
      this.carregando = false
      if (r.sucesso) {
        this.cotasTodos = (r.cotas || []).map(c => ({ ...c, credito: parseFloat(c.credito) || 0, entrada: parseFloat(c.entrada) || 0 }))
        if (this.cotasTodos.length) {
          const ultima = this.cotasTodos.reduce((max, c) => (c.data_importacao && c.data_importacao > max ? c.data_importacao : max), '')
          this.ultimaImportacao = ultima
        }
      }
    },
    limparSelecao() { this.selecionadas = [] },
    isSelecionada(c) { return !!this.selecionadas.find(x => x.codigo === c.codigo) },
    isBloqueada(c) {
      if (!this.selecionadas.length) return false
      const s = this.selecionadas[0]
      return c.administradora !== s.administradora || c.segmento !== s.segmento
    },
    toggleCota(c) {
      if (this.isBloqueada(c) && !this.isSelecionada(c)) return
      const idx = this.selecionadas.findIndex(x => x.codigo === c.codigo)
      if (idx >= 0) this.selecionadas.splice(idx, 1)
      else this.selecionadas.push(c)
    },
    abrirModalProposta() {
      if (!this.selecionadas.length) return
      this.entradasInput = this.selecionadas.map(c => Math.round(c.entrada).toLocaleString('pt-BR'))
      this.textoBtnCopiar = 'Copiar WhatsApp'
      this.recalcularProposta()
      this.modalAberto = true
    },
    montarMensagem() {
      const cs = this.selecionadas
      const entradas = this.entradasAjustadas
      const totC = cs.reduce((s, c) => s + c.credito, 0)
      const totE = entradas.reduce((s, v) => s + v, 0)
      const totS = cs.reduce((s, c) => s + Math.round(c.parcelas * this.parseParcVal(c.valor_parcelas)), 0)
      let msg = '🏷️ *COTAS CONTEMPLADAS — ' + cs[0].administradora + '*\n'
      msg += '📂 Segmento: ' + cs[0].segmento + '\n\n'
      msg += '━━━━━━━━━━━━━━━━━━━\n'
      if (cs.length > 1) {
        msg += '📊 *RESUMO DO AGRUPAMENTO*\n'
        msg += '• Crédito total: ' + this.fmt(totC) + '\n'
        msg += '• Entrada total: ' + this.fmt(totE) + '\n'
        msg += '• Saldo devedor total: ' + this.fmt(totS) + '\n'
        msg += '• Parcelas: ' + this.prazoCombinadoTexto + '\n\n'
        msg += '━━━━━━━━━━━━━━━━━━━\n'
      }
      cs.forEach((c, i) => {
        const p = this.parseParcVal(c.valor_parcelas)
        const sd = Math.round(c.parcelas * p)
        const entradaPct = c.credito > 0 ? ((entradas[i] / c.credito) * 100).toFixed(1) : 0
        msg += '*' + (cs.length > 1 ? 'Opção ' + (i + 1) + ' — ' : '') + 'Crédito ' + this.fmt(c.credito) + '*\n'
        msg += '• Entrada: ' + this.fmt(entradas[i]) + ' (' + entradaPct + '%)\n'
        msg += '• Parcelas: ' + c.parcelas + 'x de ' + this.fmt(p) + '/mês\n'
        msg += '• Saldo devedor: ' + this.fmt(sd) + '\n'
        msg += '• Próx. vencimento: ' + c.prox_vencimento + '\n'
        msg += '• Código: ' + c.codigo + '\n\n'
      })
      msg += '━━━━━━━━━━━━━━━━━━━\n'
      msg += '📞 Entre em contato para mais detalhes\ne condições de transferência.\n\n'
      msg += '_' + getNomeEmpresaCache() + ' — assessoria em consórcios contemplados_'
      return msg
    },
    recalcularProposta() { this.mensagemProposta = this.montarMensagem() },
    copiarPropostaCota() {
      navigator.clipboard.writeText(this.mensagemProposta).catch(() => {})
      this.textoBtnCopiar = '✓ Copiado!'
      setTimeout(() => { this.textoBtnCopiar = 'Copiar WhatsApp' }, 2500)
    },
    gerarPDFCota() {
      const cs = this.selecionadas
      if (!cs.length) return
      const entradas = this.entradasAjustadas
      const totC = cs.reduce((s, c) => s + c.credito, 0)
      const totE = entradas.reduce((s, v) => s + v, 0)
      const totS = cs.reduce((s, c) => s + Math.round(c.parcelas * this.parseParcVal(c.valor_parcelas)), 0)
      const l = this.getLogo(cs[0].administradora)

      const cotasHtml = cs.map((c, i) => {
        const p = this.parseParcVal(c.valor_parcelas)
        const sd = Math.round(c.parcelas * p)
        return '<div style="border:1px solid #e0e0e0;border-radius:8px;padding:16px;margin-bottom:12px;background:#fafff7;">' +
          '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;border-bottom:1px solid #eee;padding-bottom:8px;">' +
          '<span style="font-weight:bold;color:#4a5c2f;font-size:14px;">' + (cs.length > 1 ? 'Opção ' + (i + 1) + ' — ' : '') + this.fmt(c.credito) + '</span>' +
          '<span style="font-size:11px;color:#888;">Código: ' + c.codigo + '</span></div>' +
          '<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:12px;">' +
          '<div><div style="font-size:10px;color:#aaa;text-transform:uppercase;">Entrada</div><div style="font-weight:bold;color:#2e7d32;">' + this.fmt(entradas[i]) + '</div></div>' +
          '<div><div style="font-size:10px;color:#aaa;text-transform:uppercase;">Parcela/mês</div><div style="font-weight:bold;">' + this.fmt(p) + '</div><div style="font-size:10px;color:#888;">' + c.parcelas + 'x</div></div>' +
          '<div><div style="font-size:10px;color:#aaa;text-transform:uppercase;">Saldo devedor</div><div style="font-weight:bold;color:#c0392b;">' + this.fmt(sd) + '</div></div>' +
          '<div><div style="font-size:10px;color:#aaa;text-transform:uppercase;">Vencimento</div><div style="font-weight:bold;">' + c.prox_vencimento + '</div></div>' +
          '</div></div>'
      }).join('')

      let grupoHtml = ''
      if (cs.length > 1) {
        grupoHtml = '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:20px;">' +
          '<div style="background:#f0f9f0;border-radius:8px;padding:12px;text-align:center;"><div style="font-size:10px;color:#888;text-transform:uppercase;margin-bottom:4px;">Crédito total</div><div style="font-size:18px;font-weight:bold;color:#4a5c2f;">' + this.fmt(totC) + '</div></div>' +
          '<div style="background:#f0f9f0;border-radius:8px;padding:12px;text-align:center;"><div style="font-size:10px;color:#888;text-transform:uppercase;margin-bottom:4px;">Entrada total</div><div style="font-size:18px;font-weight:bold;color:#2e7d32;">' + this.fmt(totE) + '</div></div>' +
          '<div style="background:#fff5f5;border-radius:8px;padding:12px;text-align:center;"><div style="font-size:10px;color:#888;text-transform:uppercase;margin-bottom:4px;">Saldo devedor</div><div style="font-size:18px;font-weight:bold;color:#c0392b;">' + this.fmt(totS) + '</div></div>' +
          '</div>' +
          '<div style="background:#fff9e6;border:1px solid #ffe082;border-radius:8px;padding:10px 14px;margin-bottom:20px;font-size:13px;color:#856404;">' +
          '<strong>Parcelas mensais combinadas:</strong> ' + this.prazoCombinadoTexto + '</div>'
      }

      const h = '<!DOCTYPE html><html><head><meta charset="UTF-8">' +
        '<title>Proposta Cotas Contempladas</title>' +
        '<style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:Arial,sans-serif;background:white;padding:30px;color:#333;font-size:13px}' +
        '.header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px;padding-bottom:16px;border-bottom:3px solid #4a5c2f;}' +
        '.logo-area{display:flex;align-items:center;gap:12px;}' +
        '.logo-adm{width:36px;height:36px;border-radius:8px;background:' + l.bg + ';color:' + l.fg + ';display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;flex-shrink:0;}' +
        'h1{color:#4a5c2f;font-size:20px;}h2{color:#4a5c2f;font-size:14px;margin:20px 0 12px;}' +
        '.meta{font-size:11px;color:#888;}' +
        '@media print{body{padding:10px}}' +
        '</style></head><body>' +
        '<div class="header">' +
        '<div class="logo-area">' +
        '<div>' +
        '<h1>Proposta Comercial</h1>' +
        '<div style="display:flex;align-items:center;gap:8px;margin-top:4px;">' +
        '<div class="logo-adm">' + l.sig + '</div>' +
        '<span style="font-weight:bold;color:#555;">' + cs[0].administradora + '</span>' +
        '<span style="background:#e8f5e9;color:#2e7d32;padding:2px 8px;border-radius:8px;font-size:11px;">' + cs[0].segmento + '</span>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="meta" style="text-align:right;">' +
        '<div>Gerado em: ' + new Date().toLocaleString('pt-BR') + '</div>' +
        '<div style="margin-top:4px;">' + getNomeEmpresaCache() + '</div>' +
        '</div>' +
        '</div>' +
        (grupoHtml ? '<h2>Resumo do Agrupamento</h2>' + grupoHtml : '') +
        '<h2>' + (cs.length > 1 ? 'Cotas Incluídas' : 'Detalhes da Cota') + '</h2>' +
        cotasHtml +
        '<div style="margin-top:24px;padding-top:16px;border-top:1px solid #eee;font-size:11px;color:#888;text-align:center;">' +
        'Esta proposta é válida até a data de vencimento das cotas indicadas. Taxa de transferência: sob consulta.<br>' +
        '<strong style="color:#4a5c2f;">' + getNomeEmpresaCache() + ' — Assessoria em Consórcios Contemplados</strong>' +
        '</div>' +
        '</body></html>'

      const blob = new Blob([h], { type: 'text/html' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'Proposta_Cotas_' + cs[0].administradora.replace(/\s+/g, '_') + '_' + new Date().getTime() + '.html'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
    selecionarPDFs(e) {
      this.pdfFilesQueue = Array.from(e.target.files || [])
      this.pdfStatus = this.pdfFilesQueue.map(() => ({ texto: 'Aguardando', cor: '#aaa' }))
      this.statusImportarPdf = { texto: '', tipo: '' }
    },
    async extrairTextoPdf(file) {
      const pdfjsLib = await import('pdfjs-dist/legacy/build/pdf')
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js'
      const buf = await file.arrayBuffer()
      const doc = await pdfjsLib.getDocument({ data: buf }).promise
      let texto = ''
      for (let p = 1; p <= doc.numPages; p++) {
        const page = await doc.getPage(p)
        const content = await page.getTextContent()
        const linhas = {}
        content.items.forEach(it => {
          const y = Math.round(it.transform[5])
          if (!linhas[y]) linhas[y] = []
          linhas[y].push(it)
        })
        const ys = Object.keys(linhas).map(Number).sort((a, b) => b - a)
        ys.forEach(y => {
          const itens = linhas[y].sort((a, b) => a.transform[4] - b.transform[4])
          texto += itens.map(it => it.str).join(' ') + '\n'
        })
      }
      return texto
    },
    async importarPDFs() {
      if (!this.pdfFilesQueue.length) return
      this.importandoPdf = true
      this.statusImportarPdf = { texto: '', tipo: '' }
      let totalIns = 0
      let totalErr = 0
      for (let i = 0; i < this.pdfFilesQueue.length; i++) {
        const f = this.pdfFilesQueue[i]
        this.pdfStatus.splice(i, 1, { texto: 'Lendo...', cor: '#aaa' })
        try {
          const texto = await this.extrairTextoPdf(f)
          this.pdfStatus.splice(i, 1, { texto: 'Enviando...', cor: '#aaa' })
          const r = await apiPost('cotas/importar-pdf', { texto, nomeArquivo: f.name })
          if (r.sucesso) {
            totalIns += r.total || 0
            this.pdfStatus.splice(i, 1, { texto: '✓ ' + (r.total || 0) + ' cotas importadas', cor: '#2e7d32' })
          } else {
            totalErr++
            this.pdfStatus.splice(i, 1, { texto: 'Erro: ' + (r.mensagem || 'falha'), cor: '#c0392b' })
          }
        } catch (e) {
          totalErr++
          this.pdfStatus.splice(i, 1, { texto: 'Erro: ' + e.message, cor: '#c0392b' })
        }
      }
      let msg = 'Importação concluída: ' + totalIns + ' cota(s) processada(s)'
      if (totalErr > 0) msg += ' | ' + totalErr + ' erro(s)'
      this.statusImportarPdf = { texto: msg, tipo: totalErr > 0 && totalIns === 0 ? 'erro' : 'sucesso' }
      this.importandoPdf = false
      this.ultimaImportacao = new Date().toLocaleDateString('pt-BR') + ' ' + new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
      await this.carregar()
    },
    async excluirUltimaImportacao() {
      if (!confirm('Excluir todas as cotas da ultima importacao? Esta acao nao pode ser desfeita.')) return
      this.excluindoImportacao = true
      const r = await apiDelete('cotas/excluir-ultima-importacao')
      this.excluindoImportacao = false
      if (r.sucesso) {
        this.statusImportarPdf = { texto: (r.total || 0) + ' cota(s) da ultima importacao excluida(s).', tipo: 'sucesso' }
        await this.carregar()
      } else {
        this.statusImportarPdf = { texto: r.mensagem || 'Erro ao excluir.', tipo: 'erro' }
      }
    }
  }
}
</script>
